module.exports = __webpack_public_path__ + "static/media/icon-left-arrow.9e4016c3.svg";